import React, { Component } from 'react'
import Activity from "framework/containers/Activity"

//redux
import { connect } from 'react-redux'
import { mapStateToProps, mapDispatchToProps } from 'framework/utils/Redux'

class PortfolioActivity extends Component {
	constructor(props){
		super(props)
		this.RenderedComponent = import("app/components/Web/Portfolio/PortfolioBrowser")
	}

	render() {
		return (
			<Activity 
				name="Portfolio"
				RenderedComponent={this.RenderedComponent}
                context="Portfolio"
			/>
		)
	}
}

export default connect(mapStateToProps,mapDispatchToProps)(PortfolioActivity)